import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "home align-items-center d-flex flex-column justify-content-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "home_text" }, "Nuevos grupos", -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Más info")
const _hoisted_4 = { class: "container" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h2", { class: "d-flex justify-content-around m-4" }, "Profesores", -1)
const _hoisted_6 = { class: "list-group-item-success" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_button = _resolveComponent("b-button")!
  const _component_PorqueNosotrosVue = _resolveComponent("PorqueNosotrosVue")!
  const _component_CursosOnMainPage = _resolveComponent("CursosOnMainPage")!
  const _component_SobreElCentroOnMainPage = _resolveComponent("SobreElCentroOnMainPage")!
  const _component_teacher_card = _resolveComponent("teacher-card")!
  const _component_ContactosOnMainPage = _resolveComponent("ContactosOnMainPage")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createVNode(_component_b_button, {
        class: "moreinfo-button m-3",
        pill: ""
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_PorqueNosotrosVue),
    _createVNode(_component_CursosOnMainPage),
    _createVNode(_component_SobreElCentroOnMainPage),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createElementVNode("ul", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.teachers || [], (teacher) => {
          return (_openBlock(), _createElementBlock("li", {
            key: teacher,
            class: "container__list items-list"
          }, [
            _createVNode(_component_teacher_card, {
              lastname: teacher.lastname,
              image: teacher.image,
              firstname: teacher.firstname,
              userId: teacher.id
            }, null, 8, ["lastname", "image", "firstname", "userId"])
          ]))
        }), 128))
      ]),
      _createVNode(_component_ContactosOnMainPage)
    ])
  ], 64))
}